import React from 'react';
import PropTypes from 'prop-types';
import './StatCardGroup.css';

/**
 * StatCardGroup Component
 * Container component for displaying multiple StatCard components with proper layout and background
 *
 * @param {React.ReactNode} children - StatCard components to display
 * @param {string} className - Additional CSS classes (optional)
 */
const StatCardGroup = ({ children, className = '' }) => {
	return (
		<div className={`stat-card-group ${className}`.trim()}>
			<div className="stat-card-grid">{children}</div>
		</div>
	);
};

StatCardGroup.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

StatCardGroup.defaultProps = {
	className: '',
};

export default StatCardGroup;
